import React from 'react';
import './src/scss/site-styles.scss';
import GlobalContextProvider from './src/containers/GlobalContextProvider';

// eslint-disable-next-line react/prop-types
export const wrapRootElement = ({ element }) => {
  // eslint-disable-next-line react/jsx-filename-extension
  return <GlobalContextProvider>{element}</GlobalContextProvider>;
};
